import React from "react"

type Props = {
	showError: boolean
}

const ValuationInfoBox: React.FC<Props> = ({showError}) => {
  const BASE_URL = `${window.location.origin}`

  return (
	<div className="valuationInfoBox-container">
	  {!showError && <p className="valuationInfoBox-heading">Someone from Lookers will get in touch to discuss buying your vehicle.</p>}
	  <p className="valuationInfoBox-paragraph">
			*The valuation provided is based on the details you have submitted and is valid for 7 days. It is also subject to terms and conditions and full vehicle appraisal.
    </p>
		<p className="valuationInfoBox-paragraph">You are under no obligation to sell us your vehicle.</p>
		<div className="valuationInfoBox-linkContainer">
			<a 
				className="ValuationInfoBox-link"
				href={`${BASE_URL}/terms-and-conditions/click-and-sell-faqs`} 
				target="_blank" 
				rel="noopener noreferrer"
			>
				Read all Click &amp; Sell FAQs
			</a>
		</div>
	</div>	
  );
};

export default ValuationInfoBox;